import React, {useEffect} from 'react';

import "./PDSAPlanTabTwo.css";
import DatePicker from "react-datepicker";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {NextButton} from "../../../../../../common/button/next-button/NextButton";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";

export const PDSAPlanTabTwo = ({
                                   PDSA,
                                   setPDSA,
                                   setCurrentScreen,
                                   context,
                                   setContext,
                                   navigateTo,
                                   setActiveTab,
                                   savePDSA,
                                   active,
                                   setSpinnerText,
                                   showToaster,
                                   toolTipsEnabled
                               }) => {

    useEffect(() => {
        setActiveTab("plan");
    }, []);

    const isButtonDisabled = () => {
        return !PDSA.testStartDate || !PDSA.scale || !PDSA.testReviewDate;
    }

    const handleNextClick = () => {
        if (active) {
            savePDSA(() => {
                setCurrentScreen("PDSADoTabOne");
            })
        } else {
            setCurrentScreen("PDSADoTabOne");
        }
    }

    return (
        <div className="plan-tab-two-container">
            <div className="plan-tab-two-input-container">
                <div className="input-container">
                    <div>
                        <label>Test Start Date:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaTestStartDate123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Test Start Date:"}/>}
                    </div>
                    <DatePicker selected={PDSA.testStartDate}
                                className="text-input"
                                dateFormat='dd/MM/yyyy'
                                showPopperArrow={false}
                                placeholderText="Select..."
                                disabled={!active || !context.editMode}
                                onChange={(selectedDate) => {
                                    setPDSA((prevState) => ({
                                        ...prevState,
                                        testStartDate: selectedDate
                                    }));
                                }}/>
                </div>
                <div className="input-container">
                    <div>
                        <label>Scale:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsascale123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Scale:"}/>}
                    </div>
                    <input className="text-input"
                           onChange={({target}) => {
                               setPDSA((prevState) => ({
                                   ...prevState,
                                   scale: target.value
                               }));
                           }}
                           defaultValue={PDSA.scale ? PDSA.scale : null}
                           disabled={!active || !context.editMode}
                    />
                </div>
                <div className="input-container">
                    <div>
                        <label>Test Review Date:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaTestReviewDate123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Test Review Date:"}/>}
                    </div>
                    <DatePicker selected={PDSA.testReviewDate}
                                className="text-input"
                                disabled={!active || !context.editMode}
                                dateFormat='dd/MM/yyyy'
                                showPopperArrow={false}
                                placeholderText="Select..."
                                onChange={(selectedDate) => {
                                    setPDSA((prevState) => ({
                                        ...prevState,
                                        testReviewDate: selectedDate
                                    }));
                                }}/>
                </div>
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview" onClick={() => {
                    navigateTo("problemTree");
                }}/>
            </div>
            {!PDSA.externalReference && <div className="plan-tab-two-save-pdsa-button-container">
                <StandardButton text="Save PDSA" disabled={isButtonDisabled()} onClick={() => {
                    savePDSA(() => {
                        setContext((prevState) => ({
                            ...prevState,
                            problemToBeViewedExternalReference: context.problemScreen.externalReference,
                        }));
                        navigateTo("problemTree");
                    })
                }}/>
            </div>}
            {!PDSA.externalReference && <div className="plan-tab-two-back-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSAPlanTabOne");
                }}/>
            </div>}
            {PDSA.externalReference && <div className="pdsa-navigation-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSAPlanTabOne");
                }}/>
                <NextButton disabled={isButtonDisabled()} onClick={handleNextClick}/>
            </div>}
        </div>
    );
}
